import React from "react";
import "./App.css";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Video1 from "./Videos/Video-1";
import Video2 from "./Videos/Video-2";
import Video3 from "./Videos/Video-3";
import { WaveCanvas, SiteNav, SiteFooter } from "./Home";
const Photo1 =
  "/images/wajdi-bouallegue-artistic-gymnastics-international-competition.jpg";
const Photo2 =
  "/images/wajdi-bouallegue-floor-2012-artistic-gymnastic-summer-olympics.jpg";
const Photo3 = "/images/wajdi-bouallegue-artistic-gymnastics-career.jpg";
const Photo4 =
  "/images/wajdi-bouallegue-performing-vault-international-competition.jpg";
const Photo5 = "/images/wajdi-bouallegue-winning-gold-medal.jpg";
const Photo6 = "/images/wajdi-bouallegue-coaching-athletes.jpg";
const Photo7 = "/images/wajdi-bouallegue-and-dad.jpg";

export default function About() {
  const { t } = useTranslation();

  const gallery = [
    { src: Photo6, alt: "Wajdi Bouallègue coaching his athletes" },
    { src: Photo4, alt: "Wajdi Bouallègue performing vault" },
    { src: Photo5, alt: "Wajdi Bouallègue winning gold medal" },
    { src: Photo7, alt: "Wajdi Bouallègue with his dad" },
  ];

  return (
    <>
      <Helmet>
        <title>Olympic Wave | About Wajdi Bouallègue</title>
        <meta
          name="description"
          content="Learn about Wajdi Bouallègue, former Tunisian Olympic gymnast and elite coach."
        />
        <meta
          name="keywords"
          content="Wajdi Bouallègue, Tunisian gymnast, Olympic gymnast Tunisia, gymnastics coach Wajdi Bouallègue, African Championships gymnastics"
        />
        <meta
          property="og:title"
          content="Wajdi Bouallègue | Olympic Gymnast and Elite Coach"
        />
        <meta
          property="og:description"
          content="Discover the journey of Wajdi Bouallègue, Olympic gymnast and elite coach."
        />
        <meta property="og:type" content="profile" />
        <meta property="og:url" content="https://olympicwave.ca/about" />
        <link rel="canonical" href="https://olympicwave.ca/about" />
      </Helmet>

      <WaveCanvas />
      <div className="ow-page">
        <SiteNav />

        <main className="ow-inner" style={{ maxWidth: "1200px" }}>
          <div className="ow-page-header">
            <p className="ow-eyebrow">Olympic Wave</p>
            <h1 className="ow-page-title">Wajdi Bouallègue</h1>
          </div>

          <div className="ow-about-flow">
            <p className="ow-about-p">{t("text1")}</p>

            <div className="ow-img-frame-2">
              <img
                src={Photo2}
                alt="Wajdi Bouallègue competing on floor at the 2012 Summer Olympics"
              />
            </div>

            <p className="ow-about-p">{t("text2")}</p>

            <div className="ow-img-frame">
              <img
                src={Photo1}
                alt="Wajdi Bouallègue performing a gymnastics routine at an international competition"
              />
            </div>

            <p className="ow-about-p">{t("text3")}</p>

            <div className="ow-img-frame">
              <img
                src={Photo3}
                alt="Wajdi Bouallègue in his international artistic gymnastics career"
              />
            </div>

            <p className="ow-about-p">{t("text4")}</p>
            <p className="ow-about-p">{t("text5")}</p>

            <div className="ow-gallery">
              {gallery.map(({ src, alt }) => (
                <div key={alt} className="ow-gallery-item">
                  <img src={src} alt={alt} />
                </div>
              ))}
            </div>

            <div className="ow-video-section">
              <h2 className="ow-video-title">{t("video")}</h2>
              <div className="ow-video-stack">
                <Video1 />
                <Video2 />
                <Video3 />
              </div>
            </div>
          </div>
        </main>

        <SiteFooter />
      </div>
    </>
  );
}
